module.exports = __webpack_public_path__ + "Lato-Medium.863b7dcd5ec2c3923122.ttf";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Medium.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Medium.ttf
// module chunks = styles